module.exports = __webpack_public_path__ + "tables/media/signupImg.86119dcf.svg";